export default "__VITE_ASSET__DquX$Nfn__"